export default {"src":"/_next/static/media/search.b547fba3.svg","height":76,"width":77,"blurWidth":0,"blurHeight":0};